<template>
  <div :class="`${prefixClass}-quick-jumper`">{{ gotoText }}<input v-model="page$" class="input" type="text" @blur="$_changeValue" @keyup.enter="$_changeValue">{{ pText }}</div>
</template>
<script>
import { isPInt } from '../../utils/assist'
import Locale from '../../mixins/locale'
import { PREFIX_CLASS } from '../../utils/constants'
const PREFIXCLASS = `${PREFIX_CLASS}pagination__options`

export default {
  name: 'TPageElevator',
  mixins: [Locale],
  props: {
    current: {
      type: Number,
      validator: value => isPInt(value) && value > 0,
      default: 1
    }
  },
  data() {
    return {
      prefixClass: PREFIXCLASS,
      page$: 1
    }
  },
  computed: {
    gotoText() {
      return this.t('t.page.goto')
    },
    pText() {
      return this.t('t.page.p')
    }
  },
  methods: {
    // 设置私有方法
    $_changeValue() {
      if (isPInt(this.page$)) {
        this.$emit('on-change', parseInt(this.page$))
      } else {
        this.page$ = this.current
      }
    },
    gotoFirst() {
      this.page$ = 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/pager/elevator.vue